import script from "./FooterEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterEditor.vue?vue&type=script&setup=true&lang=js"

import "./FooterEditor.vue?vue&type=style&index=0&id=630ba8c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630ba8c6"]])

export default __exports__